import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-exibir-segmentacao',
  templateUrl: './exibir-segmentacao.component.html',
  standalone: false
})
export class ExibirSegmentacaoComponent {
  @Input() titulo: string = '';
  @Input() itens: string[] = [];
  @Input() tipoFiltro: number = 0;
  
  @Output() editarClick = new EventEmitter<number>();

  mostrarTodos: boolean = false;

  toggleMostrarTodos(event: Event) {
    event.preventDefault();
    this.mostrarTodos = !this.mostrarTodos;
  }

  editarFiltro() {
    this.editarClick.emit(this.tipoFiltro);
  }
}
